// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import Loader from "../components/Loader";

// const RequireAdminAuth = ({ children }) => {
//   const { loading, userInfo } = useSelector((state) => state.userLogin);

//   if (loading) {
//     return <Loader />;
//   }
//   if (!userInfo) {
//     return <Navigate to="/login" />;
//   } else if (
//     (userInfo && userInfo.isSuperAdmin == true) ||
//     userInfo.isPartner == true
//   ) {
//     return children;
//   } else {
//     // alert("Not authorized. Please log in.");
//   }
// };

// export default RequireAdminAuth;

import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../components/Loader";
import { userLogout } from "../redux/Actions/userAction";
import api from "../redux/service/api";

const RequireAdminAuth = ({ children }) => {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const { loading, userInfo } = useSelector((state) => state.userLogin);
  const dispatch = useDispatch();

  useEffect(() => {
    const verifyToken = async () => {
      if (!userInfo) {
        setCheckingAuth(false);
        return;
      }

      try {
        const { data } = await api.get("api/auth/validate-token");

        // If tokenVersion is missing or doesn't match, log out the user
        if (
          !userInfo.tokenVersion ||
          data.tokenVersion !== userInfo.tokenVersion
        ) {
          dispatch(userLogout());
          localStorage.removeItem("userInfo");
          setCheckingAuth(false);
        } else {
          setCheckingAuth(false);
        }
      } catch (error) {
        dispatch(userLogout());
        localStorage.removeItem("userInfo");
        setCheckingAuth(false);
      }
    };

    verifyToken();
  }, [dispatch, userInfo]);

  if (loading || checkingAuth) {
    return <Loader />;
  }

  // Redirect if no user info
  if (!userInfo) {
    return <Navigate to="/login" />;
  }

  // Check if user is a (Super Admin or Partner)
  if (userInfo.isSuperAdmin || userInfo.isPartner) {
    return children;
  }

  // Redirect unauthorized users
  return <Navigate to="/" />;
};

export default RequireAdminAuth;
